import React from "react";
import PropTypes from "prop-types";
import "../style.scss";

import { makeStyles } from "@material-ui/core/styles";

export default function InputCheckboxMaster(props) {
  const { id, checked, name, label, endContent = false, marginTop = "0.5rem", ...others } = props;

  let root = "";
  if (endContent) {
    root = {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginTop: marginTop,
      fontSize: "12px",
      justifyContent: "flex-end",
    };
  } else {
    root = {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginTop: marginTop,
      fontSize: "12px",
    };
  }

  const useStyles = makeStyles({
    root: root,
    size: {
      height: "12px",
      width: "12px",
    },
  });

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <input
        type="checkbox"
        checked={checked}
        id={id}
        name={name}
        className={classes.size}
        {...others}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}

InputCheckboxMaster.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
